// Map our custom plan IDs ("basic", "premium", etc) to Stripe price IDs
// const stripePriceIds = {
//   'FREE TRIAL': process.env.REACT_APP_STRIPE_PRICE_FREETRIAL,
//   'PAID': process.env.REACT_APP_STRIPE_PRICE_PAID,
// };

const priceLookups = {
  "PAID": {
    current: process.env.REACT_APP_STRIPE_PRICE_PAID,
    legacy: ["price_1S9qAHHXTx6zWkiX6WYPUJKO", "price_1SGOtaHXTx6zWkiXGWAaRUME"],
  },
  "FREE TRIAL": {
    current: process.env.REACT_APP_STRIPE_PRICE_FREETRIAL,
    legacy: [],
  }
};

// Get Stripe priceId
// export function getStripePriceId(planId) {
//   return stripePriceIds[planId];
// }
export function getStripePriceId(planId) {
  return priceLookups[planId]?.current || null;
}

// Get friendly plan ID ("basic", "premium", etc) by Stripe plan ID
// Used in auth.js to include planId in the user object
// export function getFriendlyPlanId(stripePriceId) {
//   console.log(Object.keys(stripePriceIds).find(
//     (key) => stripePriceIds[key] === stripePriceId
//   ))
//   return Object.keys(stripePriceIds).find(
//     (key) => stripePriceIds[key] === stripePriceId
//   );
// }
export function getFriendlyPlanId(stripePriceId) {
  return Object.keys(priceLookups).find(planId => {
    const plan = priceLookups[planId];
    return plan.current === stripePriceId || plan.legacy.includes(stripePriceId);
  });
}